var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-card-container',{class:[
    'ar-simple-card-skeleton',
    _vm.showAs ]},[_c('ar-skeleton',{staticClass:"left-section",attrs:{"level":_vm.level}}),_vm._v(" "),_c('div',{staticClass:"right-section"},[_c('am2-typography-skeleton',{staticClass:"text-skeleton upper",style:({
        maxWidth: '200px',
      }),attrs:{"size":"sm","level":_vm.level + 2}}),_vm._v(" "),_c('am2-typography-skeleton',{staticClass:"text-skeleton lower",style:({
        maxWidth: '250px',
      }),attrs:{"size":"xs","level":_vm.level + 2}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }